var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from "react";
import { getTranslate, Translate } from "react-localize-redux";
import { connect } from "react-redux";
import { ElementsValuesType, NumberType, PresentationElementType, SchemaElementTypes, UIElementType, ValidationLevel, } from "../../interfaces/store/actions/payload/schema/schemaElements";
import { getFormErrors, isVisibleConditionalField, parseTextUrls } from "../common";
import { setJobElementErrors, setTaskElementErrors, updateJobElementsValues, updateTaskElementsValues, } from "../../store/actions/schema";
import SchemaElementWrapper from "./SchemaElementWrapper";
import { processFieldValidation } from "./SchemaValidation";
import { getElementData, getElementsValues, getValidationErrors } from "./schemaUtils";
import CompositeElementWrapper from "./CompositeElementWrapper";
var RepeatableAction;
(function (RepeatableAction) {
    RepeatableAction[RepeatableAction["ADD"] = 0] = "ADD";
    RepeatableAction[RepeatableAction["REMOVE"] = 1] = "REMOVE";
    RepeatableAction[RepeatableAction["UPDATE"] = 2] = "UPDATE";
})(RepeatableAction || (RepeatableAction = {}));
var SchemaElementsFactory = (function (_super) {
    __extends(SchemaElementsFactory, _super);
    function SchemaElementsFactory(props) {
        var _this = _super.call(this, props) || this;
        _this.fallbackValues = {};
        _this.updateFieldValue = _this.updateFieldValue.bind(_this);
        _this.getFieldError = _this.getFieldError.bind(_this);
        _this.determineRepeatableValue = _this.determineRepeatableValue.bind(_this);
        _this.addRepeatableField = _this.addRepeatableField.bind(_this);
        _this.removeRepeatableField = _this.removeRepeatableField.bind(_this);
        _this.onFallbackUpdate = _this.onFallbackUpdate.bind(_this);
        _this.processValidation = _this.processValidation.bind(_this);
        _this.validateField = _this.validateField.bind(_this);
        _this.validateForm = _this.validateForm.bind(_this);
        _this.getValuesType = _this.getValuesType.bind(_this);
        _this.retrieveElementsValues = _this.retrieveElementsValues.bind(_this);
        return _this;
    }
    SchemaElementsFactory.prototype.componentDidMount = function () {
        var _a = this.props, updateTaskElementsValues = _a.updateTaskElementsValues, updateJobElementsValues = _a.updateJobElementsValues, schemaKey = _a.schemaKey, initFallbackValues = _a.initFallbackValues, metadataId = _a.metadataId;
        if (initFallbackValues) {
            if (this.getValuesType() === ElementsValuesType.TASK) {
                updateTaskElementsValues({
                    schemaKey: schemaKey,
                    metadataId: metadataId,
                    values: this.fallbackValues,
                });
            }
            else {
                updateJobElementsValues({
                    schemaKey: schemaKey,
                    metadataId: metadataId,
                    values: this.fallbackValues,
                });
            }
        }
    };
    SchemaElementsFactory.prototype.getValuesType = function () {
        var elementsValuesType = this.props.elementsValuesType;
        return (elementsValuesType ? elementsValuesType : ElementsValuesType.TASK);
    };
    SchemaElementsFactory.prototype.retrieveElementsValues = function () {
        var _a = this.props, schemaKey = _a.schemaKey, elementsValuesMap = _a.elementsValuesMap, metadataId = _a.metadataId;
        return getElementsValues({
            metadataId: metadataId,
            elementsValuesMap: elementsValuesMap,
            schemaKey: schemaKey,
            elementsValuesType: this.getValuesType()
        });
    };
    SchemaElementsFactory.prototype.determineRepeatableValue = function (repeatableItemInfo) {
        var fieldName = repeatableItemInfo.fieldName, index = repeatableItemInfo.index, value = repeatableItemInfo.value, action = repeatableItemInfo.action;
        var segmentId = this.props.segmentId;
        var elementsValues = this.retrieveElementsValues();
        var elementName = segmentId ? segmentId + "_" + fieldName : fieldName;
        var fieldValue = elementsValues && elementsValues[elementName]
            ? elementsValues[elementName]
            : [];
        if (!Array.isArray(fieldValue)) {
            fieldValue = [fieldValue];
        }
        switch (action) {
            case RepeatableAction.REMOVE:
                fieldValue.splice(index, 1);
                break;
            case RepeatableAction.ADD: {
                var newValue = value;
                if (fieldValue.length > 0) {
                    fieldValue.splice(index, 0, newValue);
                }
                else {
                    fieldValue.splice(index, 0, newValue, newValue);
                }
                break;
            }
            case RepeatableAction.UPDATE:
                fieldValue.splice(index, 1, value);
                break;
            default:
                break;
        }
        return fieldValue;
    };
    SchemaElementsFactory.prototype.addRepeatableField = function (fieldName, index, defaultValue, refElements) {
        var value = this.determineRepeatableValue({
            fieldName: fieldName,
            index: index + 1,
            value: defaultValue,
            action: RepeatableAction.ADD
        });
        this.updateFieldValue({ fieldName: fieldName, value: value, refElements: refElements });
    };
    SchemaElementsFactory.prototype.removeRepeatableField = function (fieldName, index, refElements) {
        var value = this.determineRepeatableValue({
            fieldName: fieldName,
            index: index,
            value: "",
            action: RepeatableAction.REMOVE
        });
        this.updateFieldValue({ fieldName: fieldName, value: value, refElements: refElements });
    };
    SchemaElementsFactory.prototype.onFallbackUpdate = function (fieldName, value, refElements) {
        if (refElements === void 0) { refElements = {}; }
        var _a = this.props, schemaKey = _a.schemaKey, updateTaskElementsValues = _a.updateTaskElementsValues, updateJobElementsValues = _a.updateJobElementsValues, segmentId = _a.segmentId, metadataId = _a.metadataId;
        var fallback = refElements && refElements[fieldName];
        if (fallback === null || fallback === void 0 ? void 0 : fallback.refFallbackElements) {
            var referencedValues_1 = {};
            var elementsValues_1 = this.retrieveElementsValues();
            var elementName_1;
            Object.keys(fallback.refFallbackElements).forEach(function (reference) {
                elementName_1 = segmentId ? segmentId + "_" + reference : reference;
                if (!elementsValues_1 || !elementsValues_1[elementName_1]) {
                    referencedValues_1[elementName_1] = value;
                }
            });
            if (this.getValuesType() === ElementsValuesType.TASK) {
                updateTaskElementsValues({
                    schemaKey: schemaKey,
                    metadataId: metadataId,
                    values: referencedValues_1,
                });
            }
            else {
                updateJobElementsValues({
                    schemaKey: schemaKey,
                    metadataId: metadataId,
                    values: referencedValues_1,
                });
            }
        }
    };
    SchemaElementsFactory.prototype.processValidation = function (fieldName, value, refElements) {
        var _a;
        var validationLevel = this.props.validationLevel;
        var elementsValues = this.retrieveElementsValues() || {};
        var validationScope = validationLevel || ValidationLevel.FIELD;
        var valuesToValidate = __assign(__assign({}, elementsValues), (_a = {}, _a[fieldName] = value, _a));
        switch (validationScope) {
            case ValidationLevel.FIELD:
                this.validateField(valuesToValidate, fieldName, refElements);
                break;
            case ValidationLevel.FORM:
                this.validateForm(valuesToValidate);
                break;
            default:
                break;
        }
    };
    SchemaElementsFactory.prototype.updateFieldValue = function (_a) {
        var _b;
        var fieldName = _a.fieldName, value = _a.value, _c = _a.index, index = _c === void 0 ? -1 : _c, _d = _a.refElements, refElements = _d === void 0 ? {} : _d;
        var _e = this.props, updateTaskElementsValues = _e.updateTaskElementsValues, updateJobElementsValues = _e.updateJobElementsValues, schemaKey = _e.schemaKey, segmentId = _e.segmentId, metadataId = _e.metadataId;
        var fieldValue = index === -1
            ? value
            : this.determineRepeatableValue({ fieldName: fieldName, index: index, value: value, action: RepeatableAction.UPDATE });
        this.onFallbackUpdate(fieldName, fieldValue, refElements);
        var elementName = segmentId ? segmentId + "_" + fieldName : fieldName;
        var elementsValues = (_b = {}, _b[elementName] = fieldValue, _b);
        if (this.getValuesType() === ElementsValuesType.TASK) {
            updateTaskElementsValues({
                schemaKey: schemaKey,
                metadataId: metadataId,
                values: elementsValues,
            });
        }
        else {
            updateJobElementsValues({
                schemaKey: schemaKey,
                metadataId: metadataId,
                values: elementsValues,
            });
        }
        this.processValidation(elementName, fieldValue, refElements);
    };
    SchemaElementsFactory.prototype.getFieldError = function (fieldName, repeatableIdx) {
        var _a = this.props, validationErrorsMap = _a.validationErrorsMap, schemaKey = _a.schemaKey, metadataId = _a.metadataId;
        var validationErrors = getValidationErrors({
            metadataId: metadataId,
            schemaKey: schemaKey,
            validationErrorsMap: validationErrorsMap,
            elementsValuesType: this.getValuesType(),
        });
        var fieldErrorDetails;
        if (validationErrors === null || validationErrors === void 0 ? void 0 : validationErrors.length) {
            var fieldError_1;
            Object.values(validationErrors).forEach(function (validationError, idx) {
                var repeatableMatch = (repeatableIdx !== undefined && validationError.repeatableIdx !== undefined) ? repeatableIdx === validationError.repeatableIdx : true;
                if (validationError.name === fieldName && repeatableMatch) {
                    fieldError_1 = validationError;
                }
            });
            if (fieldError_1) {
                fieldErrorDetails = {
                    validateStatus: "error",
                    help: fieldError_1.error,
                };
            }
        }
        return fieldErrorDetails;
    };
    SchemaElementsFactory.prototype.validateForm = function (elementsValues) {
        var _a = this.props, element = _a.element, references = _a.references, translate = _a.translate, schemaKey = _a.schemaKey, segmentId = _a.segmentId, metadataId = _a.metadataId, setTaskElementErrors = _a.setTaskElementErrors, setJobElementErrors = _a.setJobElementErrors;
        var allErrors = getFormErrors(elementsValues, element, references, schemaKey, translate, segmentId);
        if (this.getValuesType() === ElementsValuesType.TASK) {
            setTaskElementErrors({
                schemaKey: schemaKey,
                metadataId: metadataId,
                validationErrors: allErrors,
            });
        }
        else {
            setJobElementErrors({
                schemaKey: schemaKey,
                metadataId: metadataId,
                validationErrors: allErrors,
            });
        }
    };
    SchemaElementsFactory.prototype.validateField = function (elementsValues, fieldName, refElements) {
        var _a = this.props, translate = _a.translate, validationErrorsMap = _a.validationErrorsMap, schemaKey = _a.schemaKey, metadataId = _a.metadataId, setJobElementErrors = _a.setJobElementErrors, setTaskElementErrors = _a.setTaskElementErrors;
        var field = refElements[fieldName];
        var valueType = this.getValuesType();
        var validationErrors = getValidationErrors({
            metadataId: metadataId,
            schemaKey: schemaKey,
            validationErrorsMap: validationErrorsMap,
            elementsValuesType: valueType,
        });
        var allErrors = validationErrors.filter(function (error) { return error.name !== field.fieldName; });
        var errors = processFieldValidation(elementsValues, field, translate);
        if (errors.length) {
            allErrors = allErrors.concat(errors);
        }
        if (valueType === ElementsValuesType.TASK) {
            setTaskElementErrors({
                schemaKey: schemaKey,
                metadataId: metadataId,
                validationErrors: allErrors,
            });
        }
        else {
            setJobElementErrors({
                schemaKey: schemaKey,
                metadataId: metadataId,
                validationErrors: allErrors,
            });
        }
    };
    SchemaElementsFactory.prototype.updateFallbackValues = function (fieldName, fallbackValue) {
        var initFallbackValues = this.props.initFallbackValues;
        if (initFallbackValues && fallbackValue) {
            this.fallbackValues[fieldName] = fallbackValue;
        }
    };
    SchemaElementsFactory.prototype.createElement = function (elements, reference, refIndex) {
        var _this = this;
        var _a;
        var _b = this.props, uiElements = _b.uiElements, parseLabelUrls = _b.parseLabelUrls, segmentId = _b.segmentId, presentationElements = _b.presentationElements, translate = _b.translate, metadataId = _b.metadataId, metadataReadOnly = _b.metadataReadOnly, onSave = _b.onSave;
        var elementsValues = this.retrieveElementsValues();
        var currentElement = elements[reference];
        var elementKey = refIndex + "-" + reference + "-" + metadataId + "-form-item";
        var label = currentElement.label;
        if (parseLabelUrls) {
            var parsedLabel = parseTextUrls(currentElement.label);
            if (parsedLabel.length) {
                label = parsedLabel;
            }
        }
        var segmentPrefix = segmentId ? segmentId + "_" : "";
        var presentationUiElements = presentationElements ? presentationElements : {};
        switch (currentElement.uiType) {
            case UIElementType.CHECKBOX: {
                var elementData = getElementData({
                    element: currentElement,
                    elementsValues: elementsValues,
                    segmentPrefix: segmentPrefix,
                    elements: elements,
                    translate: translate
                });
                var fieldName = elementData.fieldName, required = elementData.required, repeatable = elementData.repeatable, readOnly = elementData.readOnly, hidden = elementData.hidden, _c = elementData.valueHolder, fieldValue = _c.fieldValue, defaultValue = _c.defaultValue, fallbackValue = _c.fallbackValue;
                this.updateFallbackValues(fieldName, fallbackValue);
                return (React.createElement(SchemaElementWrapper, { key: elementKey, fieldInput: uiElements[UIElementType.CHECKBOX], container: presentationUiElements[PresentationElementType.CONTAINER], repeatableActions: presentationUiElements[PresentationElementType.REPEATABLE_ACTIONS], contentProps: {
                        refElements: elements,
                        segmentId: segmentId,
                        label: label,
                        value: fieldValue,
                        fieldName: fieldName,
                        required: required,
                        repeatable: repeatable,
                        elementKey: elementKey + "-" + reference,
                        defaultValue: defaultValue,
                        elementType: UIElementType.CHECKBOX,
                        index: -1,
                        readOnly: readOnly || !!metadataReadOnly,
                        hidden: hidden,
                        onChange: this.updateFieldValue,
                        getFieldError: this.getFieldError,
                        addRepeatableField: this.addRepeatableField,
                        removeRepeatableField: this.removeRepeatableField,
                        onSave: onSave,
                    } }));
            }
            case UIElementType.SEGMENT: {
                var segmentElement = currentElement;
                return segmentElement.spanReferences.map(function (fieldRef, index) {
                    return _this.createElement(currentElement.refElements, fieldRef, index);
                });
            }
            case UIElementType.RELATION: {
                var relationElement = currentElement;
                return relationElement.fieldReferences.map(function (fieldRef, index) {
                    return _this.createElement(currentElement.refElements, fieldRef, index);
                });
            }
            case UIElementType.COMBO: {
                var elementData = getElementData({
                    element: currentElement,
                    elementsValues: elementsValues,
                    segmentPrefix: segmentPrefix,
                    elements: elements,
                    translate: translate
                });
                var fieldName = elementData.fieldName, allowedValues = elementData.allowedValues, required = elementData.required, repeatable = elementData.repeatable, readOnly = elementData.readOnly, hidden = elementData.hidden, _d = elementData.valueHolder, fieldValue = _d.fieldValue, defaultValue = _d.defaultValue, fallbackValue = _d.fallbackValue;
                this.updateFallbackValues(fieldName, fallbackValue);
                return (React.createElement(SchemaElementWrapper, { key: elementKey, fieldInput: uiElements[UIElementType.COMBO], container: presentationUiElements[PresentationElementType.CONTAINER], repeatableActions: presentationUiElements[PresentationElementType.REPEATABLE_ACTIONS], contentProps: {
                        refElements: elements,
                        segmentId: segmentId,
                        label: label,
                        value: fieldValue,
                        fieldName: fieldName,
                        allowedValues: allowedValues,
                        required: required,
                        repeatable: repeatable,
                        elementKey: elementKey + "-" + reference,
                        defaultValue: defaultValue,
                        index: -1,
                        readOnly: readOnly || !!metadataReadOnly,
                        hidden: hidden,
                        onSelect: this.updateFieldValue,
                        getFieldError: this.getFieldError,
                        addRepeatableField: this.addRepeatableField,
                        removeRepeatableField: this.removeRepeatableField,
                        onSave: onSave,
                    } }));
            }
            case UIElementType.CONDITIONAL: {
                var conditionalElement = currentElement;
                var anyOf = conditionalElement.anyOf, whenReference = conditionalElement.whenReference, refElements_1 = conditionalElement.refElements, fieldReferences = conditionalElement.fieldReferences;
                return isVisibleConditionalField({
                    fieldName: segmentPrefix + whenReference,
                    whenReference: whenReference,
                    anyOfValues: anyOf,
                    value: elementsValues || {},
                    element: conditionalElement,
                })
                    && fieldReferences.map(function (fieldRef, index) { return (_this.createElement(refElements_1, fieldRef, index)); });
            }
            case UIElementType.DECORATION: {
                var decorationElement = currentElement;
                return decorationElement.fieldReferences.map(function (fieldRef, index) {
                    return _this.createElement(currentElement.refElements, fieldRef, index);
                });
            }
            case UIElementType.COMPOSITE: {
                var compositeElement = currentElement;
                var fieldName = compositeElement.fieldName, label_1 = compositeElement.label, description = compositeElement.description, descriptionUrl = compositeElement.descriptionUrl, navigation = compositeElement.navigation, inline = compositeElement.inline, layout = compositeElement.layout;
                var children = compositeElement.fieldReferences
                    ? compositeElement.fieldReferences.map(function (fieldRef, index) { return _this.createElement(currentElement.refElements, fieldRef, index); })
                    : [];
                return (React.createElement(CompositeElementWrapper, { key: elementKey, compositeClass: uiElements[UIElementType.COMPOSITE], children: children, contentProps: {
                        segmentId: segmentId,
                        fieldName: fieldName,
                        label: label_1,
                        description: description,
                        descriptionUrl: descriptionUrl,
                        elementKey: elementKey + "-" + reference,
                        elementType: UIElementType.COMPOSITE,
                        children: children,
                        inline: inline,
                        navigation: navigation,
                        layout: layout,
                    } }));
            }
            case UIElementType.MULTISELECT: {
                var elementData = getElementData({
                    element: currentElement,
                    elementsValues: elementsValues,
                    segmentPrefix: segmentPrefix,
                    elements: elements,
                    translate: translate
                });
                var fieldName = elementData.fieldName, schemaType = elementData.schemaType, allowedValues = elementData.allowedValues, required = elementData.required, repeatable = elementData.repeatable, readOnly = elementData.readOnly, hidden = elementData.hidden, _e = elementData.valueHolder, fieldValue = _e.fieldValue, defaultValue = _e.defaultValue, fallbackValue = _e.fallbackValue;
                this.updateFallbackValues(fieldName, fallbackValue);
                return (React.createElement(SchemaElementWrapper, { key: elementKey, fieldInput: uiElements[UIElementType.MULTISELECT], container: presentationUiElements[PresentationElementType.CONTAINER], repeatableActions: presentationUiElements[PresentationElementType.REPEATABLE_ACTIONS], contentProps: {
                        refElements: elements,
                        segmentId: segmentId,
                        label: label,
                        value: fieldValue,
                        fieldName: fieldName,
                        required: required,
                        repeatable: repeatable,
                        elementKey: elementKey + "-" + fieldName,
                        allowedValues: allowedValues,
                        defaultValue: defaultValue,
                        index: -1,
                        readOnly: readOnly || !!metadataReadOnly,
                        hidden: hidden,
                        isStringType: schemaType === SchemaElementTypes.STRING_TYPE,
                        onChange: this.updateFieldValue,
                        getFieldError: this.getFieldError,
                        addRepeatableField: this.addRepeatableField,
                        removeRepeatableField: this.removeRepeatableField,
                        onSave: onSave,
                    } }));
            }
            case UIElementType.RADIO: {
                var elementData = getElementData({
                    element: currentElement,
                    elementsValues: elementsValues,
                    segmentPrefix: segmentPrefix,
                    elements: elements,
                    translate: translate
                });
                var fieldName = elementData.fieldName, allowedValues = elementData.allowedValues, required = elementData.required, repeatable = elementData.repeatable, readOnly = elementData.readOnly, hidden = elementData.hidden, _f = elementData.valueHolder, fieldValue = _f.fieldValue, defaultValue = _f.defaultValue, fallbackValue = _f.fallbackValue;
                this.updateFallbackValues(fieldName, fallbackValue);
                return (React.createElement(SchemaElementWrapper, { key: elementKey, fieldInput: uiElements[UIElementType.RADIO], container: presentationUiElements[PresentationElementType.CONTAINER], repeatableActions: presentationUiElements[PresentationElementType.REPEATABLE_ACTIONS], contentProps: {
                        refElements: elements,
                        segmentId: segmentId,
                        label: label,
                        value: fieldValue,
                        fieldName: fieldName,
                        allowedValues: allowedValues,
                        required: required,
                        repeatable: repeatable,
                        elementKey: elementKey + "-" + reference,
                        defaultValue: defaultValue,
                        index: -1,
                        readOnly: readOnly || !!metadataReadOnly,
                        hidden: hidden,
                        onChange: this.updateFieldValue,
                        getFieldError: this.getFieldError,
                        addRepeatableField: this.addRepeatableField,
                        removeRepeatableField: this.removeRepeatableField,
                        onSave: onSave,
                    } }));
            }
            case UIElementType.SLIDER: {
                var elementData = getElementData({
                    element: currentElement,
                    elementsValues: elementsValues,
                    segmentPrefix: segmentPrefix,
                    elements: elements,
                    translate: translate,
                });
                var fieldName = elementData.fieldName, required = elementData.required, repeatable = elementData.repeatable, readOnly = elementData.readOnly, hidden = elementData.hidden, _g = elementData.valueHolder, fieldValue = _g.fieldValue, defaultValue = _g.defaultValue, fallbackValue = _g.fallbackValue, min = elementData.min, max = elementData.max;
                this.updateFallbackValues(fieldName, fallbackValue);
                return (React.createElement(SchemaElementWrapper, { key: elementKey, fieldInput: uiElements[UIElementType.SLIDER], container: presentationUiElements[PresentationElementType.CONTAINER], repeatableActions: presentationUiElements[PresentationElementType.REPEATABLE_ACTIONS], contentProps: {
                        refElements: elements,
                        segmentId: segmentId,
                        label: label,
                        value: fieldValue,
                        fieldName: fieldName,
                        required: required,
                        repeatable: repeatable,
                        elementKey: elementKey + "-" + reference,
                        defaultValue: defaultValue,
                        index: -1,
                        readOnly: readOnly || !!metadataReadOnly,
                        hidden: hidden,
                        onChange: this.updateFieldValue,
                        getFieldError: this.getFieldError,
                        addRepeatableField: this.addRepeatableField,
                        removeRepeatableField: this.removeRepeatableField,
                        onSave: onSave,
                        min: min,
                        max: max,
                    } }));
            }
            case UIElementType.SPAN: {
                var spanElement = currentElement;
                return (_a = spanElement.fieldReferences) === null || _a === void 0 ? void 0 : _a.map(function (fieldRef, index) {
                    return _this.createElement(currentElement.refElements, fieldRef, index);
                });
            }
            case UIElementType.TEXT: {
                var elementData = getElementData({
                    element: currentElement,
                    elementsValues: elementsValues,
                    segmentPrefix: segmentPrefix,
                    elements: elements,
                    translate: translate
                });
                var fieldName = elementData.fieldName, required = elementData.required, repeatable = elementData.repeatable, readOnly = elementData.readOnly, hidden = elementData.hidden, _h = elementData.valueHolder, fieldValue = _h.fieldValue, defaultValue = _h.defaultValue, fallbackValue = _h.fallbackValue;
                this.updateFallbackValues(fieldName, fallbackValue);
                return (React.createElement(SchemaElementWrapper, { key: elementKey, fieldInput: uiElements[UIElementType.TEXT], container: presentationUiElements[PresentationElementType.CONTAINER], repeatableActions: presentationUiElements[PresentationElementType.REPEATABLE_ACTIONS], contentProps: {
                        refElements: elements,
                        segmentId: segmentId,
                        label: label,
                        value: fieldValue,
                        fieldName: fieldName,
                        required: required,
                        repeatable: repeatable,
                        elementKey: elementKey + "-" + fieldName,
                        defaultValue: defaultValue,
                        index: -1,
                        readOnly: readOnly || !!metadataReadOnly,
                        hidden: hidden,
                        onChange: this.updateFieldValue,
                        getFieldError: this.getFieldError,
                        addRepeatableField: this.addRepeatableField,
                        removeRepeatableField: this.removeRepeatableField,
                        onSave: onSave,
                    } }));
            }
            case UIElementType.TEXTAREA: {
                var elementData = getElementData({
                    element: currentElement,
                    elementsValues: elementsValues,
                    segmentPrefix: segmentPrefix,
                    elements: elements,
                    translate: translate
                });
                var fieldName = elementData.fieldName, required = elementData.required, repeatable = elementData.repeatable, readOnly = elementData.readOnly, hidden = elementData.hidden, _j = elementData.valueHolder, fieldValue = _j.fieldValue, defaultValue = _j.defaultValue, fallbackValue = _j.fallbackValue;
                this.updateFallbackValues(fieldName, fallbackValue);
                return (React.createElement(SchemaElementWrapper, { key: elementKey, fieldInput: uiElements[UIElementType.TEXTAREA], container: presentationUiElements[PresentationElementType.CONTAINER], repeatableActions: presentationUiElements[PresentationElementType.REPEATABLE_ACTIONS], contentProps: {
                        refElements: elements,
                        segmentId: segmentId,
                        label: label,
                        value: fieldValue,
                        fieldName: fieldName,
                        required: required,
                        repeatable: repeatable,
                        elementKey: elementKey + "-" + fieldName,
                        defaultValue: defaultValue,
                        index: -1,
                        readOnly: readOnly || !!metadataReadOnly,
                        hidden: hidden,
                        onChange: this.updateFieldValue,
                        getFieldError: this.getFieldError,
                        addRepeatableField: this.addRepeatableField,
                        removeRepeatableField: this.removeRepeatableField,
                        onSave: onSave,
                    } }));
            }
            case UIElementType.LITERAL: {
                var elementData = getElementData({
                    element: currentElement,
                    elementsValues: elementsValues,
                    segmentPrefix: segmentPrefix,
                    elements: elements,
                    translate: translate
                });
                var fieldName = elementData.fieldName, hidden = elementData.hidden, _k = elementData.valueHolder, fieldValue = _k.fieldValue, defaultValue = _k.defaultValue, fallbackValue = _k.fallbackValue;
                this.updateFallbackValues(fieldName, fallbackValue);
                return (React.createElement(SchemaElementWrapper, { key: elementKey, fieldInput: uiElements[UIElementType.LITERAL], container: presentationUiElements[PresentationElementType.CONTAINER], contentProps: {
                        segmentId: segmentId,
                        label: label,
                        value: fieldValue,
                        fieldName: fieldName,
                        elementKey: elementKey + "-" + fieldName,
                        defaultValue: defaultValue,
                        hidden: hidden,
                    } }));
            }
            case UIElementType.INT:
            case UIElementType.FLOAT: {
                var elementData = getElementData({
                    element: currentElement,
                    elementsValues: elementsValues,
                    segmentPrefix: segmentPrefix,
                    elements: elements,
                    translate: translate
                });
                var fieldName = elementData.fieldName, required = elementData.required, repeatable = elementData.repeatable, readOnly = elementData.readOnly, hidden = elementData.hidden, _l = elementData.valueHolder, fieldValue = _l.fieldValue, defaultValue = _l.defaultValue, fallbackValue = _l.fallbackValue;
                this.updateFallbackValues(fieldName, fallbackValue);
                var numberType = currentElement.uiType === UIElementType.INT
                    ? NumberType.INTEGER
                    : NumberType.FLOAT;
                return (React.createElement(SchemaElementWrapper, { key: elementKey, fieldInput: uiElements[UIElementType.INT], container: presentationUiElements[PresentationElementType.CONTAINER], repeatableActions: presentationUiElements[PresentationElementType.REPEATABLE_ACTIONS], contentProps: {
                        refElements: elements,
                        segmentId: segmentId,
                        label: label,
                        value: fieldValue,
                        fieldName: fieldName,
                        required: required,
                        repeatable: repeatable,
                        elementKey: elementKey + "-" + fieldName,
                        defaultValue: defaultValue,
                        index: -1,
                        readOnly: readOnly || !!metadataReadOnly,
                        hidden: hidden,
                        numberType: numberType,
                        onChange: this.updateFieldValue,
                        getFieldError: this.getFieldError,
                        addRepeatableField: this.addRepeatableField,
                        removeRepeatableField: this.removeRepeatableField,
                        onSave: onSave,
                    } }));
            }
            default:
                return (React.createElement("div", { key: elementKey + "-unsupported-item", className: "df-unsupported-field" },
                    React.createElement(Translate, { id: SchemaElementsFactory.translationPath + ".unsupported.text" })));
        }
    };
    SchemaElementsFactory.prototype.render = function () {
        var _this = this;
        var _a = this.props, refElements = _a.element.refElements, references = _a.references;
        return (React.createElement("div", { className: "df-schema-fields-group-" + (references ? references.join("-") : "") }, !!refElements && references && references.map(function (ref, spanIndex) {
            return _this.createElement(refElements, ref, spanIndex);
        })));
    };
    SchemaElementsFactory.translationPath = "utils.SchemaElementsFactory";
    return SchemaElementsFactory;
}(React.Component));
var mapStateToProps = function (_a) {
    var _b = _a.schema, elementsValuesMap = _b.elementsValuesMap, validationErrorsMap = _b.validationErrorsMap, localize = _a.localize;
    return ({
        elementsValuesMap: elementsValuesMap,
        translate: getTranslate(localize),
        validationErrorsMap: validationErrorsMap,
    });
};
var mapDispatchToProps = {
    updateTaskElementsValues: updateTaskElementsValues,
    updateJobElementsValues: updateJobElementsValues,
    setTaskElementErrors: setTaskElementErrors,
    setJobElementErrors: setJobElementErrors,
};
export default connect(mapStateToProps, mapDispatchToProps)(SchemaElementsFactory);
